/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* istanbul ignore file */
import React, { ReactElement } from "react";
import { Paragraph } from "../../components/Paragraph";
import { DefaultHoofdstuk } from "../../../../.generated/rapportage/rapportagetypes";
import Heading from "../../components/Heading";
import { Chapter } from "../../components/Chapter";

type GeadviseerdeProductenProps = {
  geadviseerdeProducten: DefaultHoofdstuk | null;
};

const GeadviseerdeProductenChapter = ({
  geadviseerdeProducten,
}: GeadviseerdeProductenProps): ReactElement => {
  return (
    <Chapter>
      <Heading text="Geadviseerde producten" level={2} />
      <Paragraph>
        {geadviseerdeProducten?.paragrafen?.p3050600?.inhoud}
      </Paragraph>
    </Chapter>
  );
};

export default GeadviseerdeProductenChapter;
